import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { useRole } from '../contexts/RoleContext';
const HomePage = () => {
    const userRole = useRole();
    const isAdmin = userRole.roleName === 'ODM Admin';

    return (
        <Layout>
            <div className="heading">
                <h1>ODM Self Service Portal</h1>
            </div>
            <div className="main-actions">
                <div className="action-card">
                    <Link to="/new-request" className="card-content">
                        <h2>Launch New Request</h2>
                    </Link>
                </div>
                <div className="action-card">
                    <Link to="/track-requests" className="card-content">
                        <h2>Track Existing Requests</h2>
                    </Link>
                </div>
                {isAdmin && (
                    <div className="action-card">
                        <Link to="/tem-upload" className="card-content">
                            <h2>TEM Inventory Upload</h2>
                            <p style={{ fontSize: '0.85em', color: '#666', margin: '4px 0 0' }}>Admin only</p>
                        </Link>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default HomePage;